import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import Loading from "../Shared/Loading";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Checkout = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const { product_id } = useParams();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { data: product, isLoading } = useQuery("product", () =>
    fetch(
      `https://evening-peak-35730.herokuapp.com/product/${product_id}`
    ).then((res) => {
      return res.json();
    })
  );

  const onSubmit = async (data) => {
    // console.log(data);

    const order = {
      customer_name: data.customer_name,
      mobile_number: data.mobile_number,
      address: data.address,
      product_quantity: data.product_quantity,
      product_name: product.product_name,
      product_image: product.product_image,
      product_price: product.product_price,
      order_status: "pending",
    };

    setLoading(true);
    const response = await fetch(
      "https://evening-peak-35730.herokuapp.com/order",
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(order),
      }
    );
    const result = await response.json();
    if (result) {
      setLoading(false);
      if (!result.success) {
        toast.error(result?.message);
      } else {
        // console.log(result);
        toast.success(
          `Ordered ${product.product_name} Successfully. ALhamdulillah!!`
        );
        navigate(`/checkout/confirmOrder/${result.result.insertedId}`);
      }
      reset();
    }
  };

  if (isLoading || loading) {
    return <Loading></Loading>;
  }

  return (
    <main>
      <section>
        <div className="card lg:card-side bg-base-100">
          <div className="card w-96 bg-base-100">
            <figure className="px-10 pt-10">
              <img
                src={product?.product_image}
                alt="product_img"
                className="rounded-xl"
              />
            </figure>
            <div className="card-body items-center text-center">
              <h2 className="card-title">{product.product_name}</h2>
              <p className="text-xl text-secondary">Price : 1200 Tk.</p>
            </div>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-control mt-3">
                <label className="label">
                  <span className="label-text text-primary font-bold">
                    Your Name
                  </span>
                </label>
                <input
                  type="text"
                  placeholder="your name"
                  className="input input-bordered text-primary"
                  {...register("customer_name", {
                    required: {
                      value: true,
                      message: "Name is required.",
                    },
                  })}
                />
                <label className="label">
                  {errors.customer_name?.type === "required" && (
                    <span className="label-text-alt font-bold text-error">
                      {errors.customer_name.message}
                    </span>
                  )}
                </label>
              </div>
              <div className="form-control mt-3">
                <label className="label">
                  <span className="label-text text-primary font-bold">
                    Mobile Number
                  </span>
                </label>
                <input
                  type="text"
                  placeholder="mobile number"
                  className="input input-bordered text-primary"
                  {...register("mobile_number", {
                    required: {
                      value: true,
                      message: "Mobile number is required.",
                    },
                    minLength: {
                      value: 11,
                      message: "Mobile number must have 11 character.",
                    },
                    maxLength: {
                      value: 11,
                      message: "Mobile number must have 11 character.",
                    },
                  })}
                />
                <label className="label">
                  {errors.mobile_number?.type === "required" && (
                    <span className="label-text-alt font-bold text-error">
                      {errors.mobile_number.message}
                    </span>
                  )}
                  {errors.mobile_number?.type === "minLength" && (
                    <span className="label-text-alt font-bold text-error">
                      {errors.mobile_number.message}
                    </span>
                  )}
                  {errors.mobile_number?.type === "maxLength" && (
                    <span className="label-text-alt font-bold text-error">
                      {errors.mobile_number.message}
                    </span>
                  )}
                </label>
              </div>
              <div className="form-control mt-3">
                <label className="label">
                  <span className="label-text text-primary font-bold">
                    Address
                  </span>
                </label>
                <input
                  type="text"
                  placeholder="address"
                  className="input input-bordered text-primary"
                  {...register("address", {
                    required: {
                      value: true,
                      message: "Address is required.",
                    },
                  })}
                />
                <label className="label">
                  {errors.address?.type === "required" && (
                    <span className="label-text-alt font-bold text-error">
                      {errors.address.message}
                    </span>
                  )}
                </label>
              </div>

              <div className="form-control mt-3">
                <label className="label">
                  <span className="label-text text-white font-bold">
                    Select how many product you need
                  </span>
                </label>
                <select
                  className="select input-bordered text-primary"
                  {...register("product_quantity", {
                    required: {
                      value: true,
                      message: "Product Quantity is required.",
                    },
                  })}
                >
                  <option disabled selected value="">
                    Select Quantity
                  </option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
                <label className="label">
                  {errors.product_quantity?.type === "required" && (
                    <span className="label-text-alt font-bold text-error">
                      {errors.product_quantity.message}
                    </span>
                  )}
                </label>
              </div>

              <div className="form-control mt-6">
                <button className="btn btn-primary">Order Now</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Checkout;
